import { apiClient } from '../../config/axios.config'; // Adjust the import path as necessary
import { BASE_ATTENDANCE_URL, BASE_URL } from '../apiConfig';

export const fetchAttendanceDetails = async payload => {
  const response = await apiClient.create(
    `${BASE_URL}${BASE_ATTENDANCE_URL}`,
    payload,
  );
  return response;
};
